module.exports = __webpack_public_path__ + "img/chase_slide_3.23950604.jpg";